<template>
  <el-submenu :index="menuItem.id + ''">
    <template slot="title">
      <i class="mr-[10px] !text-[18px] font-bold" :class="menuItem.menuIcon"></i>
      <span slot="title">{{ menuItem.name }}</span>
    </template>
    <template v-if="menuItem.children && menuItem.children.length > 0">
      <!-- 
        $listeners：包含父作用域v-on事件监听器，包含了作用在这个组件上的所有事件监听器，子组件继承了父组件的事件 
        这个地方使用，解决组件递归调用丢失$emit事件传值问题
      -->
      <MenuItem
        v-for="submenu in menuItem.children"
        :key="submenu.id"
        :menuItem="submenu"
        :menuPath="menuPath"
        v-on="$listeners"
      ></MenuItem>
    </template>
    <template
      v-if="menuItem.permissionList && menuItem.permissionList.length > 0"
    >
      <el-menu-item
        v-for="val in menuItem.permissionList"
        :index="val.tableId"
        :key="val.id"
        @click="goPage(val)"
      >
        <div slot="title">
          <el-tooltip
            placement="right-start"
            :content="val.menuName"
            v-if="val.menuName.length > 8"
          >
            <div :ref="`${val.tableId}`">
              {{ val.menuName.slice(0, 6) + "..." }}
            </div>
          </el-tooltip>
          <!-- 添加当前元素唯一标识 -->
          <div v-else :ref="`${val.tableId}`">
            {{ val.menuName }}
          </div>
        </div>
      </el-menu-item>
    </template>
  </el-submenu>
</template>

<script>
export default {
  name: "MenuItem",
  props: {
    menuItem: {
      type: Object,
      require: true,
    },
    menuPath: {
      type: String,
      require: true,
    },
  },
  mounted() {},
  methods: {
    // 路由跳转
    goPage(item) {
      // 判断是否是外部链接
      let reg = new RegExp(/(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g);
      if (reg.test(item.menuUrl)) {
        this.$router.push({
          path: "/outerPath",
          query: { id: item.tableId, url: item.menuUrl },
        });
      } else {
        this.$router.push({ path: item.menuUrl, query: { id: item.tableId } });
      }
    },
  },
};
</script>
